const throwNotSupported = (...args: any) => {
  throw new Error('Not supported on server');
};

const localStorage = __IS_BROWSER__
  ? window.localStorage
  : ({
      setItem: throwNotSupported,
      removeItem: throwNotSupported,
      getItem: throwNotSupported,
      clear: throwNotSupported,
      key: throwNotSupported,
      length: 0,
    } as WindowLocalStorage['localStorage']);

export default localStorage;
